/**
 * @overview 练习新增编辑页面
 * @author Ariel
 * @date 2023-09-20
 */
import React from 'react';
import { connect } from 'dva';
import { framework_tool, component_tool, utils_tool } from '../../../../tool'
import { WizTableForm } from '../../../common'
import moment from 'moment';
import './index.less'
import PracticeRule from '../rule/rule'
import PracticeAuth from '../auth/practiceAuth';

let { WizContainer, modelUtils, WizAvatarUpload, ossFileUtils } = framework_tool;
let { WizForm, WizButton, WizRow, WizCol, WizCheckbox, WizCustomSteps, WizNotice, Wizmessage, WizTooltip, WizIcon, WizDatePicker, WizTimePicker, WizInputNumber, WizRadio } = component_tool;
let { Session } = utils_tool;

const categoryConfig = WizTableForm.Config.categoryInfo(this, { apiParams: { type: 0 } })

const steps = [
  {
    title: '基础信息',
    content: 'First-content',
  },
  {
    title: '习题设计',
    content: 'Second-content',
  },
  {
    title: '受众设置',
    content: 'Last-content',
  },
];

const getParamRecord = (history) => {
  let record = {}
  if (history.location) {
    if (history.location.pathname === '/online/practice/update') {
      if (history.location.record) {
        record = history.location.record
        record.channelType = 'update'
        Session.set('practiceDetailUpd', record)
      } else {
        record = Session.get('practiceDetailUpd') || {}
      }
    }
    if (history.location.pathname === '/online/practice/add') {
      if (history.location.record) {
        record = history.location.record
        record.channelType = record.channelType || 'create'
        if (record.channelType === 'temp') {
          record.tempId = record.id
          record.id = null
          record.name = record.title
          record.categoryId = record.categoryTypeId
          record.categoryName = record.categoryType
        }
        Session.set('practiceDetailAdd', record)
      } else {
        record = Session.get('practiceDetailAdd') || {}
      }
    }
  }
  return record
}

class PracticeDetail extends WizContainer {

  componentName = 'practiceDetail';

  constructor(props) {
    super(props);
    const { history } = props;
    let record = getParamRecord(history)
    this.state = {
      current: 0,
      key: 'practiceDetail_' + new Date().getTime(),
      practiceId: record.id || '',
    }
    this.nextStepState = false;
    this.initialValue = record
    this.resetTime = new Date().getTime()
    this.clearWizCallBack = [];
    this._type = record['channelType'] //来源渠道类型
    this.tempId = record['channelType'] == 'temp' ? record.tempId : null
  }

  /**
   * ⭐ 只有路由配置时cached: true 才会有此生命周期, 且刷新逻辑需自行实现
   * 编辑时可能会触发重置,如果关键字id不同,则判定是新进入,将重新渲染表单
   */
  _componentDidRecover() {
    const { history } = this.props;
    let initialValue = {};
    if (history.location && history.location.pathname === '/online/practice/update') {
      if (history.location.record) {
        initialValue = history.location.record;
        Session.set('practiceDetailUpd', initialValue)
      } else {
        initialValue = Session.get('practiceDetailUpd') || {};
      }
    }
    if (history.location && history.location.pathname === '/online/practice/add') {
      if (history.location.record) {
        initialValue = history.location.record
        Session.set('practiceDetailAdd', initialValue)
      } else {
        initialValue = Session.get('practiceDetailAdd') || {}
      }
    }
    if (initialValue.id != this.initialValue.id) {
      this.initialValue = initialValue
      this.setState({ practiceId: initialValue.id })
    }
  }
  propsAndStateOnChange = {
    addPractice: this._stepOne.bind(this),
  }

  _stepOne(nextProps, nextState) {
    if (nextProps.addPractice.code == 1) {
      this.initialValue = nextProps.addPractice.data
      WizNotice.success('保存成功');
      if (this.nextStepState) {
        Session.set('practiceDetailAdd', this.initialValue)
        this.nextStepState = false;
        nextState.current = this.state.current + 1;
        nextState.practiceId = nextProps.addPractice.data.id
      } else {
        this.jumpPage('replaceAndDelCrumb', '/online/practice');
      }
    } else {
      this.nextStepState = false;
      WizNotice.error('保存失败：' + nextProps.addPractice.msg);
    }
    return true;
  }

  /**
   * 过滤字段值为undefined&null的字段
   * @param {Object} fieldsValue
   */
  fitterFieldsValue(fieldsValue) {
    let fitterValues = {};
    Object.keys(fieldsValue).forEach(key => {
      const value = fieldsValue[key];
      if (value != null && value != undefined) {
        fitterValues[key] = value;
      }
    })
    fitterValues['startDate'] = fitterValues['startDate'] && fitterValues['startDate'].format('YYYY-MM-DD')
    fitterValues['endDate'] = fitterValues['endDate'] && fitterValues['endDate'].format('YYYY-MM-DD')
    fitterValues['pushTime'] = fitterValues['pushTime'] && fitterValues['pushTime'].format('HH:mm')
    let questionImg = fitterValues['questionImg']
    if (questionImg && questionImg.length) {
      fitterValues['img'] = questionImg[0]['fileId']
      delete fitterValues['questionImg']
    }
    return fitterValues;
  }

  /**保存练习信息 */
  _savePractice(values) {
    let { channelType } = this.initialValue
    let apiPath = 'practice/add';
    let status = 0
    if (this.state.practiceId || channelType === 'update') {
      apiPath = 'practice/update'
      status = this.initialValue?.status || 0
    }
    let fitterValues = this.fitterFieldsValue(values)
    if (channelType === 'temp') {
      fitterValues.tempId = this.tempId
    }
    fitterValues.status = status
    this.doAction({
      path: apiPath,
      payload: {
        key: 'addPractice',
        apiParams: {
          ...fitterValues,
        }
      }
    });

  }

  /**下一步 */
  nextStep() {
    this.nextStepState = true;
  }

  /**表单底部按钮 */
  formFooter = () => {
    return (
      <WizRow className='form-btns row-item'>
        <WizCol span={24}>
          <WizButton title='保存并进入下一步' type='primary' htmlType='submit'
            onClick={e => this.nextStep()}>保存并进入下一步</WizButton>
          <WizButton title='保存并返回' htmlType='submit'>保存并返回</WizButton>
          <WizButton title='重置' type='reset' onClick={e => this._onReset()}>重置</WizButton>
        </WizCol>
      </WizRow>
    )
  }

  /**根据步骤展示内容 */
  stepView(formProps) {
    if (this.state.current == 0) {
      return <WizForm className={'form-inline'} {...formProps} />
    } else if (this.state.current == 1) {
      return <PracticeRule
        practiceId={this.state.practiceId}
        tempId={this.tempId}
        nextFunc={() => this.setState({ current: this.state.current + 1 })}
        backFunc={() => this.jumpPage('replaceAndDelCrumb', '/online/practice')}
        prevFunc={() => this.setState({ current: this.state.current - 1 })}
      />
    } else if (this.state.current == 2) {
      return <PracticeAuth
        practiceId={this.state.practiceId}
        initialValue={this.initialValue}
        nextFunc={() => this.jumpPage('replace', '/online/practice')}
        prevFunc={() => this.setState({ current: this.state.current - 1 })}
      />
    } else {
      return null;
    }
  }

  onReset = e => {
    let ref = this.refs.form
    if (ref) {
      ref.resetFields()
    }

    this.clearWizCallBack.forEach(callback => {
      callback && callback()
    })
  };

  _onClearWiz(callback) {
    if (callback) {
      this.clearWizCallBack.push(callback)
    }
  }

  _render() {
    const { practiceLoading } = this.props;
    let initialValue = this.initialValue;
    const dateFormat = 'YYYY-MM-DD'

    let columns = [
      {
        name: 'id',
        formItem: {
          type: 'hidden',
          initialValue: this.initialValue.id
        }
      },
      {
        title: '练习名称',
        name: 'name',
        formItem: {
          maxLength: 20,
          placeholder: '练习名称最多输入20个字',
          rules: [
            {
              required: true,
              message: '请输入练习名称',
            },
          ],
          initialValue: this.initialValue.name
        }
      },
      {
        title: '考试分类',
        name: 'categoryId',
        formItem: {
          rules: [{
            required: true,
            message: '请选择考试分类',
          }],
          ...categoryConfig,
          diy: WizTableForm,
          initialValue: initialValue.categoryId,
          initRows: [{ ...initialValue, id: initialValue.categoryId, name: initialValue.categoryName }],
          selectType: 'radio',
          onClearWiz:this._onClearWiz.bind(this),
        }
      },
      {
        title: '开始时间',
        formItem: {
          type: 'custom',
          render: (record, form) => {
            const { getFieldDecorator } = form
            return (
              <div style={{ width: '400px' }}>
                {
                  getFieldDecorator('startDate', {
                    rules: [{ required: true, message: '请选择开始时间', }],
                    initialValue: initialValue.startDate && moment(initialValue.startDate, 'YYYY-MM-DD') || null

                  })(
                    <WizDatePicker
                      key='startDate'
                      format={dateFormat}
                      placeholder={['请选择开始时间']}
                    />
                  )
                }
              </div>
            )
          }
        }
      },
      {
        title: '结束时间',
        name: 'endDate',
        formItem: {
          type: 'custom',
          rules: [
            { required: true, message: '请选择结束时间', }
          ],
          render: (record, form, otherProps) => {
            const { getFieldDecorator, getFieldValue, setFieldsValue } = form;
            const endDateValue = initialValue?.endDate || null;
            const _initialValue = !endDateValue || moment.isMoment(endDateValue) ? endDateValue : moment(endDateValue);
            const TmpCheckbox = ({ value, onChange, ...other }) => {
              const _onChange = (e) => {
                let callback = (call) => call && call()
                if (e.target?.checked) {
                  callback = (call) => setFieldsValue({ endDate: moment('2099-12-31 23:59:59') }, call)
                }
                callback(() => onChange && onChange(e))
              }
              return <WizCheckbox checked={value} onChange={_onChange}>长期</WizCheckbox>
            }

            let checkbox = getFieldDecorator('longer', {
              initialValue: (getFieldValue('endDate') || _initialValue) >= moment('2099-12-31 00:00:00') || false,
            })(<TmpCheckbox />)

            return (
              <div style={{ width: '400px' }}>
                {
                  [
                    getFieldDecorator('endDate', {
                      ...otherProps,
                      initialValue: _initialValue,
                    })(<WizDatePicker placeholder={'请选择结束时间'} disabled={getFieldValue('longer') || false}  format={dateFormat} />),
                    checkbox,
                  ]
                }
              </div>
            )
          }
        }
      },
      {
        title: '推送时间',
        formItem: {
          type: 'custom',
          render: (record, form) => {
            const { getFieldDecorator } = form
            return (
              <div style={{ width: '400px' }}>
                {
                  getFieldDecorator('pushTime', {
                    rules: [{ required: true, message: '请选择推送时间', }],
                    initialValue: initialValue.pushTime && moment(initialValue.pushTime, 'HH:mm') || null

                  })(
                    <WizTimePicker
                      key='pushTime'
                      format={'HH:mm'}
                      placeholder={['请选择推送时间']}
                    />
                  )
                }
              </div>
            )
          }
        }
      },
      //每日抽题数量
      {
        title: '每日练习次数',
        formItem: {
          type: 'custom',
          render: (record, form) => {
            const { getFieldDecorator } = form
            return (
              <div className='input-number-box'>
                <div className='number-input' span={5}>
                  {
                    getFieldDecorator('count', {
                      rules: [
                        { required: true, message: '请输入允许重复练习次数' },
                        { pattern: /^[0-9]{1,4}$/, message: '限制最大输入4位数' }
                      ],
                      initialValue: initialValue?.count || 0
                    })(
                      <WizInputNumber min={0} max={9999} defaultValue={initialValue?.count || 0}/>
                    )
                  }
                </div>
                <div className='tips-icon' span={2}>
                    <WizIcon type='question-circle-o' style={{ marginLeft: 10 }} />
                </div>
                <div className='tips-text'>允许考生多次参与练习，0次则不限制次数。</div>
              </div>
            )
          }
        }
      },
      {
        title: <span>
          封面图&nbsp;
          <WizTooltip title='请上传大小不超过1MB,图片尺寸建议400*266'>
            <WizIcon type='question-circle-o' />
          </WizTooltip>
        </span>,
        formItem: {
          type: 'custom',
          render: (record, form) => {
            const { getFieldDecorator } = form
            return (
              <>
                {getFieldDecorator('questionImg', {
                  initialValue: (initialValue && initialValue.img) ? [
                    { fileId: initialValue.img }
                  ] : [],
                })(
                  <WizAvatarUpload
                    accept={'.jpg, .jpeg, .png'}
                    listType={'picture-card'}
                    aspectRatio={400 / 266}
                    beforeUpload={(file) => {
                      const isLt1M = file.size / 1024 / 1024 < 1;
                      if (!isLt1M) {
                        Wizmessage.error('图片不得超过1MB!');
                      }
                      return isLt1M;
                    }}
                  />
                )}
              </>
            )
          }
        }
      },
      {
        title: '练习模式',
        name: 'mode',
        dataIndex: 'mode',
        formItem: {
          type: 'custom',
          render: (data, form) => {
            const { getFieldDecorator } = form
            const radioStyle = {
              alignItems: 'left',
              display: 'block',
              height: '35px',
              lineHeight: '35px'
            }
            return (
              <>
                {
                  getFieldDecorator('mode', {
                    rules: [{
                      required: true,
                      message: '请选择练习模式'
                    }],
                    initialValue: initialValue?.mode == 1 ? 1 : 0
                  })(
                    <WizRadio.Group defaultValue={initialValue?.mode == 1 ? 1 : 0 }>
                      <WizRadio value={1} style={radioStyle}>顺序练习</WizRadio>
                      <WizRadio value={0} style={radioStyle}>随机练习</WizRadio>
                    </WizRadio.Group>
                  )
                }
              </>
            )
          }
        }
      },
      {
        title: '练习描述',
        name: 'intro',
        dataIndex: 'intro',
        formItem: {
          type: 'textarea',
          placeholder: '选填，请提供简介内容，方便大家了解此练习，最多200字',
          maxLength: 200,
          initialValue: this.initialValue.intro
        },
      },
    ]

    let onSubmit = this._savePractice.bind(this);
    let formProps = {
      ref: 'form',
      key: this.state.practiceId || '', // ⭐如缓存路由需要刷新,必须加标识key
      loading: practiceLoading,
      columns,
      onSubmit,
      record: null,
      preview: null,
      footer: this.formFooter(),
      formItemLayout: {
        labelCol: { span: 6 },
        wrapperCol: { span: 15 }
      }
    }

    const wizCustomStepsProps = {
      header: steps,
      current: this.state.current,
      content: this.stepView(formProps),
      footer: null
    }

    return <WizCustomSteps {...wizCustomStepsProps} />
  }

  _onReset() {
    this.onReset()
  }
}

const mapStateToProps = (state, ownProps) => {
  const { practice } = state;
  const addPractice = modelUtils.getModelEntity(practice, 'addPractice');
  const load = modelUtils.getLoadingState(state, ['practice']);
  return {
    addPractice: addPractice,
    ...load
  }
};

export default connect(mapStateToProps)(PracticeDetail);
